const Images = {
    logoWhiteBgEconomics: require('./AF_MAPFRE_ECONOMICS_LOGOTIP_HOR_RGB_NEGATIVO.svg').default,
    r: require('./R-ranking.svg').default,
    eLogo: require('./mapfre-economics-e-logo.svg').default,
    rankingsTitle: require('./ranking de grupos aseguradores.svg').default,
    rankingsTitleEnglish: require('./ranking de grupos aseguradores_en.svg').default,
    expand: require('./ic_expand.png'),
    pdf_download: require('./pdf_download.png'),
    pdf_download_black: require('./pdf_download_black.png'),
    groupIcons: {
      'aegon': require('./groupLogos/aegon.svg').default,
      'allianz': require('./groupLogos/allianz.svg').default,
      'aviva': require('./groupLogos/aviva.svg').default,
      'axa': require('./groupLogos/axa.svg').default,
      'banamex': require('./groupLogos/banamex.svg').default,
      'banorte': require('./groupLogos/banorte.svg').default,
      'bbva': require('./groupLogos/bbva.svg').default,
      'bnp paribas cardif': require('./groupLogos/bnp paribas.svg').default,
      'bnp paribas cardif2': require('./groupLogos/bnp paribas.svg').default,
      'bradesco': require('./groupLogos/bradesco.svg').default,
      'brasilprev': require('./groupLogos/brasilprev.svg').default,
      'brasilprev 1': require('./groupLogos/brasilprev.svg').default,
      'crédit agricole assurance': require('./groupLogos/caf.svg').default,
      'crédit agricole assurance1': require('./groupLogos/caf.svg').default,
      'chubb': require('./groupLogos/chubb.svg').default,
      'cnp': require('./groupLogos/cnp.svg').default,
      'cnp assurances': require('./groupLogos/cnp.svg').default,
      'ergo': require('./groupLogos/ergo.svg').default,
      'ergo1': require('./groupLogos/ergo.svg').default,
      'generali': require('./groupLogos/generalli.svg').default,
      'groupama': require('./groupLogos/groupama.svg').default,
      'grupo nacional provincial': require('./groupLogos/grupo nacional provincial.svg').default,
      'grupo sura': require('./groupLogos/grupo sura.svg').default,
      'grupo sura 2': require('./groupLogos/grupo sura.svg').default,
      'grupo sura 3': require('./groupLogos/grupo sura.svg').default,
      'innovacare': require('./groupLogos/innovacare.svg').default,
      'itaú': require('./groupLogos/itau.svg').default,
      'mapfre': require('./groupLogos/mapfre.svg').default,
      'metlife': require('./groupLogos/metlife.svg').default,
      'metlife inc.': require('./groupLogos/metlife.svg').default,
      'poste vita': require('./groupLogos/postevita.svg').default,
      'porto seguro': require('./groupLogos/portoseguro.svg').default,
      'prudential': require('./groupLogos/prudential.svg').default,
      'rsa': require('./groupLogos/rsa.svg').default,
      'r+v': require('./groupLogos/r+v.svg').default,
      'sogecap': require('./groupLogos/sogecap.svg').default,
      'sogecap1': require('./groupLogos/sogecap.svg').default,
      'sogecap3': require('./groupLogos/sogecap.svg').default,
      'talanx': require('./groupLogos/talanx.svg').default,
      'triple-s': require('./groupLogos/triple-s.svg').default,
      'zurich': require('./groupLogos/zurich.svg').default
    },
    backgroundTabs: {
      Tab1: require('./backgroundTabs/bckg2red.png'),
      Tab2: require('./backgroundTabs/bckg2.png'),
      Tab3: require('./backgroundTabs/bckg3.png'),
      Tab4: require('./backgroundTabs/bckg4.png'),
      Tab5: require('./backgroundTabs/bckg5.png'),
    }

};

export default Images;
